package org.zq.astrock_ai.network

/**
 * 后端 API 根地址。
 * - Android / Desktop / iOS：默认 https://a.aiotzq.com
 * - Web 生产环境：空字符串，请求走同域 /api/…（配合 Nginx 反代）
 * - 本地 localhost 预览：直连默认后端，避免打到前端开发端口导致发不出验证码
 */
expect fun apiBaseUrl(): String

/** 原生端默认后端地址 */
const val DEFAULT_API_BASE_URL: String = "https://a.aiotzq.com"

internal fun resolveWebApiBaseUrl(hostname: String): String {
    val host = hostname.trim().lowercase()
    return if (host.isBlank() || host == "localhost" || host == "127.0.0.1" || host == "::1") {
        DEFAULT_API_BASE_URL
    } else {
        ""
    }
}
